import { createSlice } from "@reduxjs/toolkit";
import extraReducers from "./thunk/productSelectorExtraReducers";
import { PRODUCT_SELECTOR_FLOW_SLICE_NAME } from "../sliceConstants";
import productSelectorThunkActions from "./thunk/productSelectorThunk";

const initialState = {
  productData: {
    data: [],
    error: null,
    isLoading: false,
  },
  productQuestionData: {
    data: [],
    error: null,
    isLoading: false,
  },
  bestAnswerData: {
    data: [],
    error: null,
    isLoading: false,
  },
};

export const productSelectorFlowSlice = createSlice({
  name: PRODUCT_SELECTOR_FLOW_SLICE_NAME,
  initialState,
  reducers: {
    resetReports: (state) => ({ ...state, reportListing: { data: [] } }),
  },
  extraReducers,
});

export const productSelectorActions = {
  ...productSelectorFlowSlice.actions,
  ...productSelectorThunkActions,
};

export default productSelectorFlowSlice.reducer;
